@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.info-message {
  margin-top: 0;
  line-height: 22px;
  font-size: 16px;
}

.error {
  align-items: flex-start;
  && label {
    padding-top: 10px;
    color: @bulk-actions--duties-and-taxes-label--error--text-color;
  }
}
